export const AmandaGaddy = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="amandaGaddyModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/amandagaddy.jpg"
                    alt="Amanda Gaddy"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Amanda Gaddy{" "}
                    </h4>
                    <p className="modal-title">
                      <strong>Project Manager</strong>
                    </p>
                    <p style={{ paddingtop: "17px" }}>
                      <strong>
                        The harder you work, the luckier you get."
                      </strong>
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      With over 20 years of experience in commercial design and
                      construction, Amanda has worked independently and led
                      teams to complete retail design projects throughout the US
                      and internationally. She has managed up to 75 retail store
                      builds annually with budgets ranging from $50,000 to $2
                      million. Amanda’s relentless attention to detail when
                      managing budgets, schedules and communication between
                      owners, architects, contractors, vendors and consultants,
                      delivers consistent results beyond expectation. In
                      addition to project management, Amanda is a
                      licensed/qualified General Contractor in multiple states,
                      and is currently pursuing WELL Accredited Professional
                      certification.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
